export const SET_LOADING = "SET_LOADING";
export const TOGGLE_SNACKBAR = "TOGGLE_SNACKBAR";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const UPDATE_TABLE_ITEMS = "UPDATE_TABLE_ITEMS";
export const SET_SIDEBAR = "SET_SIDEBAR";
export const INITIALIZE_ROUTES = "INITIALIZE_ROUTES";
export const SET_SELECT_CRC_DIALOG = "SET_SELECT_CRC_DIALOG";
